import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=5d3d272f&scoped=true&"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=5d3d272f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3d272f",
  null
  
)

export default component.exports